module.exports = __webpack_public_path__ + "static/media/icon_market_break.4d323c9b.png";